export default __webpack_public_path__ + "static/media/pf.b73964fc.svg";